import Marquee from "react-fast-marquee";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

function resolveUrl(src) {
  if (!src) return "";
  return src.startsWith("/") ? `${BACKEND}${src}` : src;
}

export default function MarqueeStrip({ items, italic = false, outline = false, speed = 50 }) {
  const safe = (items || []).filter((it) => (it.type === "image" ? it.image_url : it.text));
  if (safe.length === 0) return null;
  return (
    <div className="overflow-hidden py-10 md:py-16 border-y border-neutral-300" data-testid="marquee-strip">
      <Marquee gradient={false} speed={speed} pauseOnHover={false}>
        {safe.map((it, i) => (
          <span key={i} className="flex items-center mx-10 md:mx-16">
            {it.type === "image" ? (
              <img
                src={resolveUrl(it.image_url)}
                alt={it.text || ""}
                className="h-16 md:h-24 lg:h-28 w-auto object-contain"
                loading="lazy"
              />
            ) : (
              <span
                className={`font-display font-black uppercase text-6xl md:text-8xl tracking-tighter ${
                  italic ? "font-serif-italic font-normal normal-case" : ""
                } ${outline ? "text-outline" : ""}`}
              >
                {it.text}
              </span>
            )}
            <span className="text-[#FF3E00] mx-6 text-6xl md:text-8xl font-display">✺</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
}
